import React from "react";

const cleanCurrencyValue = (value) => {
  const sanitized = String(value ?? "").replace(/,/g, "").replace(/[^0-9.]/g, "");
  const [integer = "", ...decimalParts] = sanitized.split(".");
  return decimalParts.length > 0
    ? `${integer}.${decimalParts.join("").slice(0, 2)}`
    : integer;
};

const formatCurrencyValue = (value) => {
  const clean = cleanCurrencyValue(value);
  if (clean === "") return "";
  const [integer = "0", decimal] = clean.split(".");
  const formattedInteger = Number(integer || 0).toLocaleString("en-US");
  return decimal === undefined ? formattedInteger : `${formattedInteger}.${decimal}`;
};

function CurrencyInput({ value, onChange, step = 50, min = 0, disabled = false, className = "", style, label = "price", ...inputProps }) {
  const applyStep = (direction) => {
    const current = Number(cleanCurrencyValue(value)) || 0;
    const next = Math.max(Number(min), current + direction * Number(step));
    onChange(String(Math.round(next * 100) / 100));
  };

  return (
    <div className={`currency-input ${disabled ? "is-disabled" : ""} ${className}`.trim()} style={style}>
      <input
        {...inputProps}
        type="text"
        inputMode="decimal"
        disabled={disabled}
        value={formatCurrencyValue(value)}
        onChange={(event) => onChange(cleanCurrencyValue(event.target.value))}
        onKeyDown={(event) => {
          if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            applyStep(event.key === "ArrowUp" ? 1 : -1);
          }
          inputProps.onKeyDown?.(event);
        }}
      />
      <span className="currency-input-steppers">
        <button type="button" tabIndex="-1" disabled={disabled} onClick={() => applyStep(1)} aria-label={`Increase ${label} by ${step}`}>▲</button>
        <button type="button" tabIndex="-1" disabled={disabled} onClick={() => applyStep(-1)} aria-label={`Decrease ${label} by ${step}`}>▼</button>
      </span>
    </div>
  );
}

export default CurrencyInput;
